module.exports = __webpack_public_path__ + "img/3.04e9a41.jpg";